import { render } from "./Show.vue?vue&type=template&id=7bc0d2c2&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=7bc0d2c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bc0d2c2"

export default script